<div class="nav_container" *ngIf="logged == 'true' && profil == 2">
  <div>
    <ul>
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Mon espace
        </li>
        <li class="mb-2">
          <a [routerLink]="['mentorat/mentorat-folder']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
            routerLinkActive="active-link">
            <svg height="24" id="svg8" version="1.1" viewBox="0 0 24 24" width="24" class="ng-tns-c1733450603-1">
              <g id="g1514" transform="translate(-0.0011279,-290.64853)" style="display: inline;"
                class="ng-tns-c1733450603-1">
                <path fill="#E5E8EC"
                  d="m 2.31126,305.45171 a 1.0001,1.0001 0 0 0 -0.2928,0.71263 l 0.0345,5.48974 a 1.0001,1.0001 0 0 0 1.00697,0.99283 l 5.42206,-0.0359 a 1.0001,1.0001 0 0 0 0.70019,-0.2914 l 11.76119,-11.76119 c 1.38704,-1.387 1.38747,-3.6622 0,-5.04918 l -1.81887,-1.81886 c -1.38708,-1.387 -3.66487,-1.387 -5.05195,-1e-5 z m 1.70976,1.11866 8.09168,-8.09168 4.04099,4.04102 -8.09442,8.09442 -4.01202,0.0262 z m 9.50588,-9.50588 1.95975,-1.95975 c 0.62801,-0.628 1.59549,-0.62798 2.2235,1e-5 l 1.81887,1.81887 c 0.62805,0.62798 0.62768,1.59273 10e-6,2.22075 l -1.96112,1.96112 z"
                  class="ng-tns-c1733450603-1"></path>
              </g>
            </svg>
            <span style="margin-left: 10px">Mes dossiers</span>
          </a>
        </li>
        <li class="mb-2">
          <a [routerLink]="['mentorat/candidaturementorat']" class="nav_item"
            style="padding-top: 3px; padding-bottom: 3px" routerLinkActive="active-link">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="mr-2 ng-tns-c1733450603-1">
              <path fill="#E5E8EC" stroke="black" stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
                class="ng-tns-c1733450603-1"></path>
            </svg>
            <span class="ml-1">Mes candidatures</span>
          </a>
        </li>

        <li>
          <a [routerLink]="['mentorat/mesgroupes']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg style="margin-left: -5px; width: 24px; height: 24px" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <!-- Icône de groupe de personnes -->
              <path fill="currentColor"
                d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
            </svg>
            <span class="ml-3">Mes groupes</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['mentorat/paiement']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg style="margin-left: -5px; width: 24px; height: 24px" viewBox="0 0 24 24" fill="none" stroke="#ffffff"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="7" width="18" height="10" rx="2" ry="2" />
              <line x1="3" y1="11" x2="21" y2="11" />
              <line x1="7" y1="15" x2="9" y2="15" />
              <circle cx="18" cy="7" r="3" />
              <path d="M16.5 7.5l1 1 2-2" />
            </svg>
            <span class="ml-3">Mes Paiements</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['mentorat/mentorcours']" class="nav_item" routerLinkActive="active-link">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="#E5E8EC" stroke="black" stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
            <span class="ml-3">Mon emploi du temps</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['users/profil']" class="nav_item" routerLinkActive="active-link">
            <svg class="text-greyLighter" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 14 18">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z" />
            </svg>
            <span class="ml-3">Mon Profil</span>
          </a>
        </li>
      </div>

    </ul>
  </div>
</div>